import { NavLink } from "react-router-dom"
import Faq from "./faq"
import { useEffect } from "react"
import { CONTACT_CONFIG } from '../config/contact'

export default function Use() {
    // Utilisation des variables de configuration centralisées
    const contactInfo = CONTACT_CONFIG;
    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <>
            {/* Header Section */}
            <section className="bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] text-white py-8 relative overflow-hidden">
                {/* Background Decoration */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full -translate-y-48 translate-x-48"></div>
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full translate-y-32 -translate-x-32"></div>
                
                <div className="h-[25vh]"></div>
                <div className="main-content relative z-10">        
                    {/* Main Title */}
                    <div className="text-center">
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
                            Términos y 
                            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                Condiciones
                            </span>
                        </h1>
                    </div>
                    {/* Navigation Breadcrumbs */}
                    <div className="text-center mb-4">
                        <span className="text-sm">
                            <NavLink 
                                to="/" 
                                className="transition-all duration-500 hover:text-yellow-400"
                                onClick={scrollToTop}
                            >
                                Inicio
                            </NavLink> / <span className="text-gray-300">Termos e Condições</span>
                        </span>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-5 sm:py-12 relative overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
                
                <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
                    <div className="space-y-8">
                        {/* Section 1 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0a1a5f] to-[#002f9c] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">1</span>
                                </div>
                                Aceitação dos termos
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                            Ao aceder ao nosso site e utilizar os nossos serviços IPTV, aceitas estes Termos e Condições. Se não estiveres de acordo com estes termos, por favor não utilizes o nosso site ou os nossos serviços.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#002f9c] to-[#0d47ff] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">2</span>
                                </div>
                                Serviços IPTV
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                
                            O TVPortugal4k oferece subscrições IPTV para te permitir desfrutar de uma grande variedade de canais e conteúdos. Estas subscrições são concebidas para oferecer uma experiência de visualização de alta qualidade sem necessidade de recolher as tuas informações pessoais.
                            </p>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed pt-2">
                            Os códigos de ativação e as instruções de instalação serão fornecidos imediatamente após a tua compra.
                            </p>
                        </div>

                        {/* Section 3 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0d47ff] to-[#1d4ed8] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">3</span>
                                </div>
                                Privacidade
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                            Não recolhemos quaisquer dados pessoais dos nossos utilizadores. Isto significa que o teu nome, endereço, informações de pagamento ou qualquer outro detalhe identificável não são recolhidos nem armazenados pelo TVPortugal4k. A tua privacidade está garantida e implementámos medidas para prevenir qualquer recolha de dados por parte de terceiros.
                            </p>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed pt-2">
                            Ao utilizar os nossos serviços, podes ter a certeza de que as tuas atividades permanecem completamente anónimas e seguras.
                            </p>
                        </div>

                        {/* Section 4 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#1d4ed8] to-[#3b82f6] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">4</span>
                                </div>
                                Pagamento
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                            Os pagamentos são realizados através de plataformas seguras de terceiros. O TVPortugal4k não armazena qualquer informação de pagamento. Por favor, segue as instruções fornecidas para finalizar a tua compra de forma segura.
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#3b82f6] to-[#60a5fa] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">5</span>
                                </div>
                                Utilização dos serviços
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                            Os serviços IPTV fornecidos pelo TVPortugal4k destinam-se apenas a uso pessoal. Não deves partilhar, redistribuir ou revender os códigos de ativação ou o conteúdo fornecido pelos nossos serviços. Qualquer utilização indevida pode resultar na suspensão da tua subscrição sem direito a reembolso.
                            </p>
                        </div>

                        {/* Section 6 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#60a5fa] to-[#93c5fd] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">6</span>
                                </div>
                                Responsabilidade
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                            O TVPortugal4k compromete-se a fornecer serviços IPTV de alta qualidade. No entanto, não podemos garantir uma disponibilidade ininterrupta devido a fatores externos, como falhas de Internet ou problemas técnicos. Não nos responsabilizamos por interrupções que estejam fora do nosso controlo.
                            </p>
                        </div>

                        {/* Section 7 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#93c5fd] to-[#bfdbfe] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">7</span>
                                </div>
                                Direitos de propriedade intelectual
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                            Todo o conteúdo fornecido pelos nossos serviços IPTV, incluindo canais, filmes e séries, está protegido por direitos de autor e leis de propriedade intelectual. Não deves gravar, distribuir ou copiar este conteúdo.
                            </p>
                        </div>

                        {/* Section 8 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#bfdbfe] to-[#dbeafe] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">8</span>
                                </div>
                                Alterações dos termos
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                            Reservamo-nos o direito de modificar estes termos a qualquer momento. Qualquer alteração será publicada no nosso site. Ao continuares a utilizar os nossos serviços após uma alteração, aceitas as novas condições.
                            </p>
                        </div>

                        {/* Section 9 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#dbeafe] to-[#eff6ff] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">9</span>
                                </div>
                                Contacta-nos
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
                            Para qualquer questão sobre estes termos e condições ou para exercer os teus direitos,
                            podes contactar-nos através de:
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm sm:text-base text-gray-600">
                                <li>Email : {contactInfo.email}</li>
                                <li>
                                    WhatsApp :{" "}
                                    <a 
                                        href={contactInfo.whatsappUrl} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="text-blue-600 underline hover:text-blue-800 transition-colors duration-300"
                                    >
                                        Clica aqui para nos contactar
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Conclusion */}
                        <div className="bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] rounded-2xl p-6 sm:p-8 text-white shadow-xl">
                            <div className="text-center">
                                <h3 className="text-lg sm:text-xl font-bold mb-4">
                                    Obrigado por escolher {contactInfo.companyName}
                                </h3>
                                <p className="text-sm sm:text-base leading-relaxed opacity-90">
                                Temos orgulho em garantir a tua privacidade e oferecer-te um serviço de alta qualidade sem comprometer a tua segurança ou o teu anonimato.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <Faq/>
            </section>
            
        </>
    )
}   
